import React, { useEffect, useState } from 'react';
//import { FiLogOut } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
//import { GoogleLogout } from 'react-google-login';
//import { googleLogout } from '@react-oauth/google';

import { userCreatedPromptsQuery, userQuery, userSavedPromptsQuery } from '../utils/data';
import { client } from '../client';
import MasonryLayout from './MasonryLayout';
import Masonic from './Masonic';
import Spinner from './Spinner';
import ItsEmptyHere from '../assets/ItsEmptyHere.png';



const UserProfile = () => {
  const [user, setUser] = useState();
  const [prompts, setPrompts] = useState();
  const [text, setText] = useState('Prompt');
  const [activeBtn, setActiveBtn] = useState('prompt');

  const { userId } = useParams();

  const User = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : localStorage.clear();

  useEffect(() => {
    const query = userQuery(userId);
    client.fetch(query).then((data) => {
      setUser(data[0]);
    });
  }, [userId]);

  useEffect(() => {
    if (text === 'Prompt') {
      const createdPromptsQuery = userCreatedPromptsQuery(userId);

      client.fetch(createdPromptsQuery).then((data) => {
        setPrompts(data);
      });
    } else {
      const savedPromptsQuery = userSavedPromptsQuery(userId);

      client.fetch(savedPromptsQuery).then((data) => {
        setPrompts(data);
      });
    }
  }, [text, userId]);


  if (!user) return <Spinner message="Loading profile" />;

  return (
    <div className="relative pb-2 h-full justify-center items-center">
      <div className="flex flex-col pb-5">
        <div className="relative flex flex-col mb-7">
          <div className="flex flex-col justify-center items-center">
            <img
              className=" w-full h-40 shadow-lg object-cover"
              src="https://images.unsplash.com/photo-1638444458366-060c19121512?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80"
              alt="user-pic"
            />
            <img
              className="rounded-full w-20 h-20 -mt-10 p-1 bg-white shadow-xl object-cover"
              src={user.image}
              alt="user-pic"
            />
          </div>
          <h1 className="sm:text-3xl text-2xl font-medium title-font text-gray-900 mb-4 text-center mt-3">
            {user.userName}
          </h1>

        </div>

        <div className="text-center mb-7">

        <ul className="menu menu-horizontal lg:menu-horizontal bg-base-100 rounded-box">
          <li key="prompt"><a onClick={(e) => {
              setText(e.target.textContent);
              setActiveBtn('prompt');
            }}
            className={`${activeBtn === 'prompt' ? "active" : ""}`}>Prompt</a></li>
          <li key="favourite"><a onClick={(e) => {
              setText(e.target.textContent);
              setActiveBtn('favourite');
            }}
            className={`${activeBtn === 'favourite' ? "active" : ""}`}>Favourite</a></li>
        </ul>

          
        </div>

        <div className="px-2">
          {prompts?.length > 0 && <MasonryLayout prompts={prompts} />}
        {/* {prompts?.length > 0 && <Masonic prompts={prompts} />} */}
        </div>

        {prompts?.length === 0 && (
        <div className='flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0'>
        <img src={ItsEmptyHere} className='w-9/10' alt='logo' />
        <p className='mt-5'>Wooooo!</p>
        <p>It's empty in here...</p>
      </div>
        )}
      </div>



    </div>
  );
};

/*

const activeBtnStyles = "bg-slate-700 hover:bg-slate-400 text-white py-2 px-6 hover:text-white focus:outline-none text-white border-b-2 font-medium border-white";
const notActiveBtnStyles = "hover:bg-slate-400 text-gray-600 py-2 px-6 hover:text-white focus:outline-none";

<button
            type="button"
            onClick={(e) => {
              setText(e.target.textContent);
              setActiveBtn('prompt');
            }}
            className={`${activeBtn === 'prompt' ? activeBtnStyles : notActiveBtnStyles}`}
          >
            Prompt
          </button>
          <button
            type="button"
            onClick={(e) => {
              setText(e.target.textContent);
              setActiveBtn('favourite');
            }}
            className={`${activeBtn === 'favourite' ? activeBtnStyles : notActiveBtnStyles}`}
          >
            Favourite
          </button>



            const navigate = useNavigate();

            const logout = () => {
    localStorage.clear();

    navigate('/login');
  };


                    <div className="absolute top-0 z-1 right-0 p-2">
          {userId === User?.sub && (
                  <button
                    type="button"
                    className='bg-black flex items-center gap-2 text-white font-bold p-2 pl-4 pr-4 rounded-full opacity-70 hover:100 hover:shadow-md'
                    onClick={() => {
                      googleLogout();
                      localStorage.removeItem('user');
                      logout();
                    }}
                  >
                    <FiLogOut color="red" fontSize={21} /> Logout
                  </button>
          )}
                
          </div>

          */

export default UserProfile;